export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: "iView-admin",
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,

  cookieIsList: 2,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: true,
  /**
   * @description api请求基础路径
   */

  // developURL:
  // "https://sso.kenvue.com/as/authorization.oauth2?client_id=ch_constore_qa&client_secret=QIBwu09mcGMik82fwTwNbHof2TVBaFiSd5v0Yc5MF0GMGQPPDCkwFJrlH4IPtbSD&response_type=code&redirect_uri=" +
  // encodeURIComponent(ssoUrl) +
  // "&nonce=" +
  // RondomPass(10),
  // developURL:
  //   "https://sso.kenvue.com/as/authorization.oauth2?client_id=ch_constore_prod&client_secret=RIzpAv3D2QLDIZaqLvc4OcgXOKbEcEotyQXPBmDVrPr9RdW7FWMtIIo9BRNI089G&response_type=code&redirect_uri="+encodeURIComponent(ssoUrl)
  //   + "&nonce=" + RondomPass(10),

  baseUrl: {
    //dev: 'http://218.202.240.118:8081/jnj/',
    // dev: 'https://concn-master-store.jnj.com/jnj/',
    // dev: "http://192.168.0.9:8081/",
    //dev: "http://localhost:8081/jnj/",
    //dev: "http://218.202.240.118:8081/jnj/",
    // dev: 'http://192.168.0.106:8081',
    //pro: 'https://isalesplus-pro.jjmc.cn/jnj/',
    dev: 'https://isalesplus-pro.jjmc.cn/jnj/',
    qa: 'https://isalesplus-pro.jjmc.cn/jnj/',
    pro: "https://isalesplus-pro.jjmc.cn/jnj/",
    //dev: "https://isalesplus-qa.jjmc.cn/jnj/",
    // dev: "http://192.168.0.12:8081/jnj/",
    // dev: "http://218.202.240.118:8099/jnj/",
    //dev: "http://218.202.240.118:8081/jnj/",
    // dev: "http://192.168.0.12:8081/jnj/",
    // pro: "http://192.168.0.12:8081/jnj/"
    // dev: "http://192.168.0.9:8081/jnj/",
    // pro: "http://192.168.0.9:8081/jnj/"
    // pro: "http://192.168.0.9:8081/"
    // pro: "http://218.202.240.118:8085/"
    // pro: 'https://concn-master-store.jnj.com/jnj/'
    // pro: 'https://concn-master-store.kenvue.com/jnj/'
    // pro: "http://218.202.240.118:8081/jnj/"
    //pro: 'http://192.168.0.106:8081'
    cdndev: "https://isalesplus-pro.jjmc.cn/",
    fcstdev: "https://isalesplus-pro.jjmc.cn/fcst/",
    fcstpro: "https://isalesplus-pro.jjmc.cn/fcst/",
    fcstWebDev: "https://isalesplus-pro.jjmc.cn/web",
    rpmdev: "https://isalesplus-pro.jjmc.cn/rpm/",
    rpmWebDev: "https://isalesplus-pro.jjmc.cn/person/#",
    kbyydev: "https://isalesplus-pro.jjmc.cn/blank/",
    kbyypro: "https://isalesplus-pro.jjmc.cn/blank/",
    kbyyWebDev: "https://isalesplus-pro.jjmc.cn/blankhospitalweb/",
  },

  // ssoUrl: {
  //   // dev: "https://concn-master-store.kenvue.com/Transit.aspx",
  //   // pro: 'http://10.221.60.215:8081/jnj/'
  //   // pro: "https://concn-master-store.kenvue.com/Transit.aspx"
  // },
  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: "home",
  /**
   * @description 需要加载的插件
   */
  plugin: {
    "error-store": {
      showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
      developmentOff: true, // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    },
  },
};



// WEBPACK FOOTER //
// ./src/config/index.js